import React, { ReactNode } from 'react';
import PaymentTabContainer from '../PaymentTabContainer';

import PaymentTypeWrapperStyles from './PaymentTypeWrapper.module.scss';

interface IPaymentTypeWrapper {
  children: ReactNode;
  id: any;
  payload: any;
  address: string;
  loading: boolean;
}
const PaymentTypeWrapper = ({ children, id, payload, address, loading }: IPaymentTypeWrapper) => {
  return (
    <div className={PaymentTypeWrapperStyles.wrapper}>
      <div className={PaymentTypeWrapperStyles.wrapper__sideTabContainer}>
        <PaymentTabContainer id={id} payload={payload} address={address} loading={loading} />
      </div>
      <div className={PaymentTypeWrapperStyles.wrapper__body}>{children}</div>
    </div>
  );
};

export default PaymentTypeWrapper;
